/* eslint-disable */
import { buildDamDriverPeriods, splitDynamicTariffNotes } from '../../utils/utils';

/** Station notes (address, availability, tariff schedule) — shown after the start/charge panel */
export default function StartPageStationNotes({ station }) {
  const noteLang = (localStorage.getItem('i18nextLng') || 'ua').split('-')[0];
  const preferUa = noteLang === 'ua' || noteLang === 'uk';
  const notesRaw = (preferUa ? station?.notesUa : station?.notesEn) || station?.notesUa || station?.notesEn || '';
  const parsed = splitDynamicTariffNotes(notesRaw, { preferUa });
  if (!parsed) {
    return null;
  }

  const {
    title,
    bodyLines,
    tiers,
    damWindows = [],
    damWindowsIsTomorrow = false,
    damWindowsInactive = false,
    isDam,
  } = parsed;
  const unit = preferUa ? ' грн' : ' UAH';
  const periods = isDam ? buildDamDriverPeriods({ tiers, damWindows, damWindowsInactive }) : [];
  const tomorrowLabel = preferUa ? 'Завтра' : 'Tomorrow';

  return (
    <div className={`start-page-notes${isDam ? ' start-page-notes--dam' : ''}`}>
      {title ? <p className="start-page-notes__title">{title}</p> : null}
      {isDam && damWindowsIsTomorrow && periods.length > 0 ? (
        <div className="start-page-notes__windows start-page-notes__windows--tomorrow">
          <span className="start-page-notes__windows-label">{tomorrowLabel}</span>
        </div>
      ) : null}
      {isDam && periods.length > 0 ? (
        <ul className="start-page-notes__list">
          {periods.map(period => (
            <li
              key={period.label}
              className={`start-page-notes__row${period.kind === 'dam' ? ' start-page-notes__row--dam' : ''}`}
            >
              <span className="start-page-notes__time">{period.label}</span>
              <span className="start-page-notes__amount">
                {period.price}
                <span className="start-page-notes__amount-unit">{unit}</span>
              </span>
            </li>
          ))}
        </ul>
      ) : null}
      {!isDam && tiers.length > 0 ? (
        <ul className="start-page-notes__list">
          {tiers.map(tier => (
            <li key={`${tier.timeLabel}-${tier.price}`} className="start-page-notes__row">
              <span className="start-page-notes__time">{tier.timeLabel}</span>
              <span className="start-page-notes__price">{tier.price}</span>
            </li>
          ))}
        </ul>
      ) : null}
      {bodyLines.length > 0 ? (
        <p className={`start-page-notes__body${isDam ? ' start-page-notes__body--footer' : ''}`}>
          {bodyLines.join('\n')}
        </p>
      ) : null}
    </div>
  );
}
